exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "[data-html-img] {\n  max-width: 100%;\n  max-height: 100%; }\n", "", {"version":3,"sources":["/usr/src/app/node_modules/clappr/src/playbacks/html_img/public/style.scss"],"names":[],"mappings":"AAAA;EACE,gBAAc;EACd,iBAAe,EAChB","file":"style.scss","sourcesContent":["[data-html-img] {\n  max-width: 100%;\n  max-height: 100%; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/postcss-loader/lib?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap&includePaths[]=/usr/src/app/node_modules/clappr/src/base/scss!./node_modules/clappr/src/playbacks/html_img/public/style.scss
// module id = 269
// module chunks = 0